export default "__VITE_ASSET__vWXCnQpk__$_?string__"